// Import dependencies
import { builderFetch } from '@builder/core/utilities';
const { isEmpty } = _uo.utility;

// Translatable strings
const strings = UncannyAutomator._core.i18n.core.itemLoop.updateLoopFilter;

/**
 * Updates a loop filter
 *
 * @param {Number} loopID The loop ID (post ID)
 * @param {Number} loopFilterID The loop filter ID (post ID)
 * @param {String} fields JSON string with the values of the fields
 * @param {String} backup JSON string with data that'll be used if the loop filter is missing in the directory
 * @return {Promise} The apiFetch promise
 */
const updateLoopFilter = ( loopID, loopFilterID, fields, backup = {} ) => {
	// Get the loop filter
	const loopFilter = UncannyAutomator._core.recipe.item.loop.getLoopFilter( loopID, loopFilterID );

	// If the item is not define, stop here
	if ( isEmpty( loopFilter ) ) {
		throw new Error( `updateLoopFilter: The filter ${ loopFilterID } doesn't exist` );
	}

	// Save the recipe title
	return builderFetch( {
		endpoint: `loop/${ UncannyAutomator._recipe.recipe_id }`,
		method: 'POST',
		data: {
			action: 'update_filter',
			// eslint-disable-next-line camelcase
			loop_id: loopID,
			// eslint-disable-next-line camelcase
			loop_filter_id: loopFilterID,
			fields: fields,
			backup: backup
		},
		snackbar: {
			loading: strings.updatingLoopFilter,
			success: strings.loopFilterUpdated,
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( 'uap/builder/core/item/loop/update-loop-filter', {
				detail: {
					loopID: loopID,
					loopFilterID: loopFilterID,
					fields: fields,
					backup: backup
				}
			} ) );
		}

		return response;
	} );
}

export default updateLoopFilter;
